import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { InputsConfig } from 'types/form/inputsConfig';

export const addressInputsConfig: InputsConfig<AddressFormFieldNames> = {
  [AddressFormFieldNames.Address]: {
    componentKey: ComponentKey.GoogleLocation,
    name: AddressFormFieldNames.Address,
    required: true,
    label: 'ACTOR_FORM.ADDRESS.LABELS.ADDRESS',
    placeholder: 'ACTOR_FORM.ADDRESS.PLACEHOLDERS.ADDRESS'
  },
  [AddressFormFieldNames.AdditionalAddress]: {
    componentKey: ComponentKey.InputText,
    name: AddressFormFieldNames.AdditionalAddress,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.ADDRESS.LABELS.ADDITIONAL_ADDRESS',
    placeholder: 'ACTOR_FORM.ADDRESS.PLACEHOLDERS.ADDITIONAL_ADDRESS'
  },
  [AddressFormFieldNames.PostalCode]: {
    componentKey: ComponentKey.InputText,
    name: AddressFormFieldNames.PostalCode,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.ADDRESS.LABELS.POSTAL_CODE',
    placeholder: 'ACTOR_FORM.ADDRESS.PLACEHOLDERS.POSTAL_CODE'
  },
  [AddressFormFieldNames.City]: {
    componentKey: ComponentKey.InputText,
    name: AddressFormFieldNames.City,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.ADDRESS.LABELS.CITY',
    placeholder: 'ACTOR_FORM.ADDRESS.PLACEHOLDERS.CITY'
  },
  [AddressFormFieldNames.Country]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.Country,
    name: AddressFormFieldNames.Country,
    required: true,
    label: 'ACTOR_FORM.ADDRESS.LABELS.COUNTRY',
    placeholder: 'ACTOR_FORM.ADDRESS.PLACEHOLDERS.COUNTRY'
  },
  [AddressFormFieldNames.GooglePlaceId]: {
    componentKey: ComponentKey.InputText,
    name: AddressFormFieldNames.GooglePlaceId,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.ADDRESS.LABELS.GOOGLE_PLACE_ID'
  },
  [AddressFormFieldNames.Latitude]: {
    componentKey: ComponentKey.InputText,
    name: AddressFormFieldNames.Latitude,
    type: 'number',
    required: false,
    label: 'ACTOR_FORM.ADDRESS.LABELS.LATITUDE'
  },
  [AddressFormFieldNames.Longitude]: {
    componentKey: ComponentKey.InputText,
    name: AddressFormFieldNames.Longitude,
    type: 'number',
    required: false,
    label: 'ACTOR_FORM.ADDRESS.LABELS.LONGITUDE'
  }
};
